import { Injectable } from "@angular/core";
import moment from "moment";
import { DatePipe } from "@angular/common";

@Injectable({
  providedIn: "root"
})
export class DateHelperService {
  constructor() {}

  convertToDefaultFormat(date: Date) {
    const dateMoment = moment(date);
    return new DatePipe("en-US").transform(
      dateMoment.toISOString(),
      "yyyy-MM-dd"
    );
  }
}
